import { z } from 'zod';

export const UpdatePositionStopSchema = z.object({
  stopPrice: z.coerce.number().positive(),
  reason: z.string().trim().optional(),
  correction: z.literal(true).optional(),
});

export type UpdatePositionStopInput = z.infer<typeof UpdatePositionStopSchema>;

export const UpdatePositionOverrideSchema = z.object({
  quantity: z.coerce
    .number()
    .finite()
    .refine((value) => value !== 0, 'Quantity cannot be zero.'),
  avgCost: z.coerce.number().positive(),
  notes: z.string().trim().min(20),
});

export type UpdatePositionOverrideInput = z.infer<typeof UpdatePositionOverrideSchema>;

export const UpdateShortProvenanceSchema = z.object({
  shortProvenance: z.enum(['CONFIRMED', 'AMBIGUOUS_PREHISTORY']),
});

export type UpdateShortProvenanceInput = z.infer<typeof UpdateShortProvenanceSchema>;

export const BrokerVerifiedFlatSchema = z.object({
  observedAt: z.string().date(),
  source: z.string().trim().min(3).max(100),
  reference: z.string().trim().min(3).max(250),
  securityIdentity: z.string().trim().min(3).max(150),
});

export type BrokerVerifiedFlatInput = z.infer<typeof BrokerVerifiedFlatSchema>;

export const UserConfirmedFlatSchema = z.object({
  observedAt: z.string().date(),
  confirmation: z.literal(true),
});

export type UserConfirmedFlatInput = z.infer<typeof UserConfirmedFlatSchema>;
